import { getOrderValue } from '@/utility/shippingCosts';

export type LinePrice = {
  discountPercent: number;
  total: number;
  discountedTotal: number;
  saved: number;
};

export const getLinePrice = (
  { price, discounts }: { price: number; discounts: ProductTypeDiscount[] },
  quantity: number
): LinePrice => {
  const discountPercent =
    discounts.find(({ from, to }) => quantity >= from && (!to || quantity <= to))?.value ?? 0;
  const discountedUnitPrice = Number((price - (price * discountPercent) / 100).toFixed(2));
  const total = getOrderValue(price, quantity);
  const discountedTotal = getOrderValue(discountedUnitPrice, quantity);

  return {
    discountPercent,
    total,
    discountedTotal,
    saved: getOrderValue(total - discountedTotal, 1),
  };
};

export const getNextTier = (
  discounts: ProductTypeDiscount[],
  quantity: number
): ProductTypeDiscount | undefined =>
  discounts.filter(({ from }) => from > quantity).sort((a, b) => a.from - b.from)[0];
